/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Project_Confirm_TitleInputs */

const en_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Project`)
};

const fr_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creer un projet`)
};

const de_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projekt erstellen`)
};

const it_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea progetto`)
};

const ru_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать проект`)
};

const es_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear proyecto`)
};

const zh_cn2_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建项目`)
};

const ja_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトを作成`)
};

const hi_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट बनाएं`)
};

const pt_pt2_new_project_confirm_title = /** @type {(inputs: New_Project_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar projeto`)
};

/**
* | output |
* | --- |
* | "Create Project" |
*
* @param {New_Project_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_project_confirm_title = /** @type {((inputs?: New_Project_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Project_Confirm_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_new_project_confirm_title(inputs)
	if (locale === "de") return de_new_project_confirm_title(inputs)
	if (locale === "it") return it_new_project_confirm_title(inputs)
	if (locale === "ru") return ru_new_project_confirm_title(inputs)
	if (locale === "es") return es_new_project_confirm_title(inputs)
	if (locale === "zh-CN") return zh_cn2_new_project_confirm_title(inputs)
	if (locale === "ja") return ja_new_project_confirm_title(inputs)
	if (locale === "hi") return hi_new_project_confirm_title(inputs)
	if (locale === "pt-PT") return pt_pt2_new_project_confirm_title(inputs)
	return en_new_project_confirm_title(inputs)
});